import { useEffect, useRef, useState } from "react";
import { ChatListCard } from "./ChatListCard"
import { RentalNotificationCard } from "./RentalNotificationCard"
import { SecondaryButton } from "../buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";
import { getUnreadNotificationsCount, getUserNotifications, markAllUserNotificationsAsRead } from "../../api/requests/notifications";
import { NotificationsListResponse } from "../../api/requests/interfaces/Notifications";
import { Spinner } from "../common/Spinner";
import {InboxNotificationType, setUnseenNotificationsCount} from "../../store/features/inboxSlice";
import {NotificationType} from "../../store/features/notificationsSlice";
import { useAppDispatch } from "../../store/hooks";

export interface RecentChatsModalProps {

    handleUnreadNotifAmount: (unreadAmount: number) => void;

}

const TAKE_NOTIFICATIONS_LEN = 10;

export const RecentChatsModal: React.FC<RecentChatsModalProps> = () => {

    const navigate = useNavigate();

    const [notifications, setNotifications] = useState<NotificationsListResponse[]>([]);
    const [lodingNotifications, setLodingNotifications] = useState(false);
    const [totalNotificationsCount, setTotalNotificationsCount] = useState<number>(0);

    const dispatch = useAppDispatch();

    const usersList = [
        {
            chatId: "hs673d6as", /* dummy data paari uleliigse fieldiga */
            name: "Nidishda",
            rentalTitle: "Makita akutrell laadijaga",
            profileImg: "https://plus.unsplash.com/premium_photo-1678197937465-bdbc4ed95815?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww",
            lastMessage: "see on juba rendis.",
            dateCreated: new Date(2024, 5, 10, 12, 30),
            rentalIsActive: true,
            userVerified: true
        },
        {
            chatId: "hs673d6as",
            name: "Yurka ",
            rentalTitle: "Mingi toode teine",
            profileImg: "https://plus.unsplash.com/premium_photo-1678197937465-bdbc4ed95815?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww",
            lastMessage: "see on juba rendis.",
            dateCreated: new Date(2024, 11, 11, 16, 10),
            rentalIsActive: false,
            userVerified: true
        },
        {
            chatId: "hs673d6as",
            name: "Liisa Karu",
            rentalTitle: "Kummipaat",
            profileImg: "https://plus.unsplash.com/premium_photo-1678197937465-bdbc4ed95815?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww",
            lastMessage: "see on juba rendis.",
            dateCreated: new Date(2024, 11, 9, 14, 10),
            rentalIsActive: true,
            userVerified: false
        },
        {
            chatId: "hs673d6as",
            name: "Austin",
            rentalTitle: "Täispuhutav loss",
            profileImg: "https://plus.unsplash.com/premium_photo-1678197937465-bdbc4ed95815?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww",
            lastMessage: "see on juba rendis.",
            dateCreated: new Date(2024, 11, 11, 14, 10),
            rentalIsActive: false,
            userVerified: false
        }
    ]

    useEffect(() => {
        loadUserNotifications();
        handleUpdateNewNotificationsCount();
    }, [])

    const loadUserNotifications = async () => {
        setLodingNotifications(true);
        const res = await getUserNotifications(10, 0);
        setTotalNotificationsCount(res.total);
        setLodingNotifications(false);
        setNotifications([...res.data]);
    }

    const handleLoadMoreNotifications = async () => {
        if (totalNotificationsCount <= notifications.length) {
            return;
        }
        const newNotifications = await getUserNotifications(TAKE_NOTIFICATIONS_LEN, notifications.length);
        setNotifications([...notifications, ...newNotifications.data]);
    }

    const handleUpdateNewNotificationsCount = async () => {
        const countNewUnreadNotifications = await getUnreadNotificationsCount();
        dispatch(setUnseenNotificationsCount(countNewUnreadNotifications));
    }

    const handleMarkAllNotificationsAsRead = async () => {
        await markAllUserNotificationsAsRead();
        await handleUpdateNewNotificationsCount();
        setNotifications(notifications.map((notification) => {
            return { ...notification, seen: true }
        }))
    }

    const handleGetNotificationCardChatPath =
        (notificationType: InboxNotificationType): string => {
        if ([InboxNotificationType.MESSAGE_SENT, InboxNotificationType.RENTAL_REQUESTED,
            InboxNotificationType.RENTAL_RETURNED].includes(notificationType)) {
            // case for products that seller has rented out
            return "chats"
        } else {
            return "rentals-chats"
        }
    }

    return (
        <div className="flex flex-col gap-2 absolute top-[120%] lg:right-0 w-full min-w-[300px] lg:w-[370px] p-2 bg-white rounded-xl shadow-main cursor-default z-40">
            <div className="flex justify-start">
                <span className="text-primary text-sm cursor-pointer hover:text-primary_darker" onClick={() => handleMarkAllNotificationsAsRead()}>Märgi kõik teavitused nähtuks</span>
            </div>
            {(notifications.length || lodingNotifications) ? <>
                <div className="max-h-[400px] overflow-y-auto">
                    {lodingNotifications ? <div className="flex justify-center"><Spinner /></div> :

                        notifications.map((data, index) => (
                            <RentalNotificationCard
                                key={index}
                                // onClick={() => { navigate(`/${
                                //     handleGetNotificationCardChatPath(data.notificationType)}?selectedChatId=`
                                //     + data.channelId, { state: { forceEffect: true } }) }}
                                onClick={() => { navigate(`/${data.userIsSeller ? "chats" : "rentals-chats" }?selectedChatId=`
                                    + data.channelId, { state: { forceEffect: true } }) }}
                                data={data}
                            
                            />
                        ))

                    }
                    {
                        totalNotificationsCount > notifications.length &&
                        <SecondaryButton title="Lae veel teavitusi" transparent={true} textSize="m" onClick={() => { handleLoadMoreNotifications() }} />
                    }
                </div>

                {/* <SecondaryButton title="Kõik vestlused" transparent={true} textSize="m" onClick={() => { navigate("/chats") }} /> */}
            </> : <div className="font-semibold text-primary pt-5 pb-5">Sul pole veel ühtegi teavitust</div>}
        </div>
    )
}

